import React, { useState, useEffect, useMemo, useRef } from "react";
import useTrack, { eventTypes } from "../../hooks/useTrack";
import BrandRow from "../WidgetComponents/Brand/BrandRow";
import { isHonestWidget, StaticCard } from "../CoreUI";
import message from "../../utils/message";
import GET from "../../utils/GET";
import { brandRowNumber } from "../../conf";
import "./widget-card.css";
import { useCallback } from "react";
import inFullscreen from "../../utils/inFullscreen";
import dummyImage from "../../img/dummy.png";
// import { Element, scroller, animateScroll as scroll, Link } from "react-scroll";

// import SendDialog from "../WidgetComponents/SendDialog";
// import validEmail from "../../utils/validEmail";
// import validPhone from "../../utils/validPhone";
// import getApiUrl from "../../utils/getApiUrl";

// const SMSOption = {
// 	headers: {
// 		"Content-Type": "application/json",
// 	},
// };

// const brandHeight = window.innerWidth > 570 ? 318 : 287
const platform = GET("platform");
const onboarding = GET("onboarding");
const selfPreview = GET("selfPreview");
const full = GET("full");
const contactEmail = GET("contactEmail");
// const live = GET("live");

const brandHeight = 318;
const heightGradient = brandRowNumber * brandHeight;
const WidgetCard = React.memo(
  ({
    brands,
    publisher,
    error,
    cost,
    purchases,
    data,
    setMinimizePPE,
    modalVisible = false,
    setPdpInfo,
    widgetState,
    ...props
  }) => {
    const postPurchase =
      inFullscreen &&
      data &&
      data.publisher_details &&
      data.publisher_details.post_purchase;

    const track = useTrack();
    const [unmounted, setUnmounted] = useState(false);
    const [widgetEmpty, setWidgetEmpty] = useState(false);
    const [lastIdx, setLastIdx] = useState(-1);

    const widgetScrollRef = useRef(null);

    // widget height
    const [currHeight, setCurrHeight] = useState(heightGradient);
    const [productIncrementor, setProductIncrementor] = useState(1);

    const maxHeight = useMemo(
      () => (brands.length - 1 + productIncrementor) * brandHeight,
      [brands, productIncrementor]
    );

    // const [showMailDialog, setMailDialog] = useState(false);
    // const [showSMSDialog, setSMSDialog] = useState(false);

    // const getEmailData = useCallback((email, brands) => {
    // 	const data = new FormData();
    // 	data.set("brands", brands);
    // 	data.set("email", email);
    // 	return data;
    // }, []);

    // const getSMSData = useCallback((phone) => {
    // 	return JSON.stringify({ phone_number: `+1${validPhone(phone)}` });
    // }, []);

    useEffect(() => {
      if (widgetState === "max") {
        return;
      }
      setCurrHeight(heightGradient);
    }, [widgetState]);

    useEffect(() => {
      if (unmounted) {
        return;
      }
      if (
        error ||
        ((!Array.isArray(brands) || brands.length === 0) &&
          (!data ||
            !Array.isArray(data.self_products.products) ||
            data.self_products.products.length === 0) &&
          (!Array.isArray(data.display_order) ||
            data.display_order.length === 0))
      ) {
        setUnmounted(true);
        message({ type: "UNMOUNT" });
      }
    }, [error, unmounted, brands, data]);

    useEffect(() => {
      if (
        (!Array.isArray(brands) || brands.length === 0) &&
        (!data ||
          !Array.isArray(data.self_products.products) ||
          data.self_products.products.length === 0)
      ) {
        setWidgetEmpty(true);
      } else {
        setWidgetEmpty(false);
      }
    }, [brands, data]);

    useEffect(() => {
      if (modalVisible || !widgetEmpty) {
        return;
      }
      if (setMinimizePPE && typeof setMinimizePPE === "function") {
        setMinimizePPE(true);
      }
    }, [modalVisible, widgetEmpty, setMinimizePPE]);

    useEffect(() => {
      if (!modalVisible && !widgetEmpty) {
        const loadMetadata = (data && data.load_metadata) || {};
        track(eventTypes.WIDGET_LOAD, {
          cost,
          purchases,
          host: GET("host"),
          num_brands: data.l && data.l.length,
          contact_email: contactEmail,
          ...loadMetadata,
        });
      }
    }, [track, cost, purchases, data, modalVisible, widgetEmpty]);

    useEffect(() => {
      const handleEvent = ({ data: { type, name, component } }) => {
        if (type !== "EVENT") {
          return;
        }
        const eventProps =
          component === "FOOTER" ? data.publisher_details.copy_object : {};
        track(name, eventProps);
      };
      window.addEventListener("message", handleEvent);
      return () => window.removeEventListener("message", handleEvent);
    }, [data, track]);

    useEffect(() => {
      message();
    }, [currHeight, productIncrementor]);

    useEffect(() => {
      if (
        data &&
        data.self_products &&
        data.self_products.products &&
        data.self_products.products.length > 0
      ) {
        setProductIncrementor(2);
      }
    }, [data]);

    const expandWidget = useCallback(() => {
      setCurrHeight((currHeight) => currHeight + heightGradient);
    }, []);

    const handleExpand = useCallback(() => {
      track(eventTypes.WIDGET_SEE_MORE_CLICK, {});
      const prevBrandsNum = document.querySelectorAll(
        ".widget-brand-header-image"
      ).length;
      expandWidget();
      setTimeout(() => {
        const currBrands = document.querySelectorAll(
          ".widget-brand-header-image"
        );
        if (
          currBrands.length <= prevBrandsNum ||
          !currBrands?.[prevBrandsNum]
        ) {
          return;
        }
        currBrands[prevBrandsNum].focus();
      }, 0);
    }, [expandWidget, track]);

    useEffect(() => {
      if (platform || full || modalVisible || widgetEmpty || !postPurchase) {
        return;
      }

      setTimeout(() => {
        message({
          type: "SCROLL_INTO_VIEW",
          payload: {
            offsetTop:
              widgetScrollRef?.current?.getBoundingClientRect().top - 50,
          },
        });
        // scroll.scrollToBottom();
        // return widgetScrollRef.current.scrollIntoView({
        // 	behavior: "smooth",
        // 	block: "start",
        // });
      }, 1000);
    }, [modalVisible, widgetEmpty, postPurchase]);

    return (
      !error && (
        <>
          {platform && !selfPreview && widgetEmpty && (
            <img
              src={dummyImage}
              className="widget-no-products-preview"
              alt="Disco"
            />
          )}
          {(!widgetEmpty || (platform && selfPreview)) && (
            <StaticCard
              heading={
                selfPreview && !onboarding
                  ? ""
                  : data && data.style.header && data.style.header !== ""
                  ? data.style.header
                  : "Customers also bought"
              }
              className={isHonestWidget ? "coop-honest-widget" : ""}
              displayCoop
              // cta
              // onClick={() => {
              // 	setMailDialog(true);
              // 	track(eventTypes.WIDGET_EMAIL_CLICK);
              // }}
              // onClickSecondary={() => {
              // 	setSMSDialog(true);
              // 	track(eventTypes.WIDGET_SMS_CLICK);
              // }}
              footer={maxHeight > currHeight && widgetState !== "max"}
              maxHeight={currHeight}
              expandClick={handleExpand}
              {...props}
            >
              <div ref={widgetScrollRef} />
              {data.self_products &&
                data.self_products.products &&
                data.self_products.products.length > 0 && (
                  <BrandRow
                    brand={data.self_products}
                    shopifyShop={data?.self_products.shopify_shop}
                    key={-1}
                    order={-1}
                    modalVisible={modalVisible}
                    upsell
                    onExpand={expandWidget}
                    postPurchase={postPurchase}
                    setPdpInfo={setPdpInfo}
                    populateCart={data?.self_products?.populate_cart}
                    idx={0}
                    setLastIdx={setLastIdx}
                    lastIdx={lastIdx}
                  />
                )}
              {brands &&
                brands.map((brand, i) =>
                  Array.isArray(brand.products) && brand.products.length > 0
                    ? brandHeight * (i + productIncrementor) <= currHeight && (
                        <BrandRow
                          key={i}
                          brand={brand}
                          order={i}
                          isLast={
                            brandHeight * (i + productIncrementor) ===
                            currHeight
                          }
                          postPurchase={postPurchase}
                          modalVisible={modalVisible}
                          onExpand={expandWidget}
                          setPdpInfo={setPdpInfo}
                          populateCart={brand?.populate_cart}
                          shopifyShop={brand?.shopify_shop}
                          widgetState={widgetState}
                          idx={i + productIncrementor - 1}
                          setLastIdx={setLastIdx}
                          lastIdx={lastIdx}
                        />
                      )
                    : null
                )}
              {/* <SendDialog
								isOpen={showMailDialog}
								close={() => setMailDialog(false)}
								brands={brands.map((brand) => brand.id)}
								helpText="Enter your email and we’ll send you this full list of products to review later"
								successText="Check your email to see these offers at anytime"
								getData={getEmailData}
								url={`${getApiUrl()}/core/email_sent/${publisher}/`}
								auto={true}
								getKey="email"
								errorText="Please enter a valid email"
								event={eventTypes.WIDGET_EMAIL_SEND}
								isValid={validEmail}
								input={{
									type: "email",
									label: "Your email",
									placeholder: "Your email",
								}}
							/> */}
              {/* <SendDialog
								isOpen={showSMSDialog}
								close={() => setSMSDialog(false)}
								helpText="Enter your phone number and we’ll send over all of these products. "
								successText="Check your phone to see these offers at anytime"
								getData={getSMSData}
								url={`${getApiUrl()}/core/text_send/${publisher}/`}
								auto={false}
								getKey="phone"
								event={eventTypes.WIDGET_SMS_SEND}
								isValid={validPhone}
								options={SMSOption}
								errorText="Please enter a valid phone number"
								input={{
									type: "tel",
									label: "Your Phone Number (US Only)",
									placeholder: "Your Phone Number",
								}}
							/> */}
            </StaticCard>
          )}
        </>
      )
    );
  }
);

export default WidgetCard;
